import {AirportDetail} from '../model/airportDetail';

export const AIRPORT_DETAIL_MOCK: AirportDetail = {
  id: '1',
  name: 'VIP-зал «Al Majlis»',
  airportName: 'Dubai International Airport',
  flag: '../assets/placeholders/uae.png',
  location: 'Dubai (UAE), Dubai Marina',
  locationCoords: {
    lat: 25.2532,
    lng: 55.3657
  },
  terminal: 'Terminal 1, International Flight',
  price: 95,
  additionalPrice: 85,
  departureDescription: `Step into a world of exclusive comfort and luxury in our premium lounge. From gourmet dining
options prepared by top chefs to private workspaces designed for productivity, every detail
has been thoughtfully crafted to elevate your travel experience. Relax in plush seating, enjoy
seamless connectivity with high-speed Wi-Fi, and take advantage of our first-class amenities,
including personalized service and a serene atmosphere. Whether you’re unwinding before your.`,
  images: [
    '../assets/mock1.png',
    '../assets/mock2.png',
    '../assets/mock3.png'
  ],
  tags: [
    { label: 'WiFi', icon: 'wifi.svg' },
    { label: 'High Reviews', icon: 'HighRev.svg' },
    { label: 'Parking', icon: 'parking.svg' },
    { label: 'VIP', icon: 'stars.svg' },
    { label: 'TV', icon: 'tv.svg' },
  ],
  additionalServices: [
    { name: 'Алкогольные напитки', price: 13430 },
    { name: 'Премиум сервис', price: 20000 }
  ],
  cancellationPolicy: 'Отмена менее чем за 48 часов — штраф 100%',
  urgencyPolicy: 'Менее 48 часов — +100$ за пассажира'
};
